import config from 'config';
import Model from 'lib/Model';

export default Model.extend({
	url: config.url.data,
	file: config.file.data,
});
